import { Cart, OrderPackage, Student } from '../../../models/_models'
import Order from '../../../models/Order'

export default async function createOrder(yearbookPackage, schoolId, formData) {
  const {
    studentId,
    firstName,
    lastName,
    grade,
    price,
    quantity,
    notes,
  } = formData

  const studentById = await Student.where({ studentId, schoolId }).first()
  const studentInfo = { firstName, lastName, grade }
  let studentByInfo = await Student.where({ ...studentInfo, schoolId }).first()

  if (!(firstName && lastName && grade)) studentByInfo = { data: null }

  const cart = new Cart({
    email: '',
    createdLocation: 'yearbook_sales',
    price,
  })

  let student
  if (studentId && studentById.data) student = studentById.data
  else student = studentByInfo.data

  let newStudent
  if (!student) {
    const createNewStudent = confirm("We couldn't find this student in our records. Would you like to create and add this student with this information (except student ID)?")

    if (createNewStudent) {
      newStudent = new Student({
        firstName,
        lastName,
        grade,
        schoolId,
      })

      await newStudent.save()
      if (newStudent.isPersisted) student = newStudent
    }
  }

  if (!student) return new Promise((resolve, reject) => reject(new Error("Couldn't find student.")))

  const orderPackages = Array.from(Array(parseInt(quantity, 10)).keys())

  cart.orderPackages = orderPackages.map(() => new OrderPackage({
    price,
    packageId: yearbookPackage.id,
    optionId: yearbookPackage.options[0].id,
    studentId: student.id,
  }))

  const order = new Order({
    firstName: student.firstName || firstName,
    lastName: student.lastName || lastName,
    notes,
    schoolPrice: parseInt(quantity, 10) * parseInt(price, 10),
  })

  cart.orders = [order]

  window.orderPackages = orderPackages
  window.order = order
  window.cart = cart

  return cart.save({ with: ['orderPackages', 'orders'] })
}
